import { css as r } from "@microsoft/fast-element";
import { normalize as e } from "../common/normalize.js";
import { display as t } from "@matrix42/fast-foundation";
import { typography as i } from "../styles/typography.js";
import { designTokens as o } from "../design-tokens.js";
const d = r`
  ${e}
  ${t("flex")}
  .control {
    display: flex;
    padding: ${o.spacing[3]};
    gap: ${o.spacing[2]};
    border-radius: ${o.borderRadius.xs};
    border: ${o.borderWidth.xs} solid
      ${o.color.neutral[60]};
    background: ${o.color.white};
    width: 100%;
    cursor: pointer;
    overflow: hidden;

    user-select: none;

    ${i("p", "regular")}
  }

  .control:hover {
    background-color: ${o.color.neutral[40]};
  }

  .control:active {
    background-color: ${o.color.neutral[50]};
  }

  .container {
    display: flex;
    flex-direction: column;
    gap: ${o.spacing[1]};
    flex: 1 0 0;
    overflow: auto;
  }

  .checkbox {
    display: flex;
    align-self: flex-start;
    justify-content: flex-start;
    flex-shrink: 0;
    width: auto;
    height: auto;
    padding: ${o.spacing[1]} 0;
  }

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: ${o.color.neutral[100]};
  }

  .header-title {
    display: flex;

    gap: ${o.spacing[2]};
  }

  .body {
    color: ${o.color.neutral[400]};
    overflow: auto;
  }

  .header,
  .body {
    user-select: text;
  }

  .header-arrow {
    width: ${o.iconSize.xs} !important;
    height: ${o.iconSize.xs} !important;
    flex-shrink: 0;
  }
`;
export {
  d as cardStyles
};
